import styled from "styled-components";

import { GraficBarInterface } from "./interfaces";

export const Container = styled.div`
    padding: 18px 15px 10px 15px;
    background: #F6F5FA 0% 0% no-repeat padding-box;
    border-radius: 12px;
    margin-top: 50px;
    width: 225px;
    height: 225px;

    @media (max-width: 1200px) {
        width: 400px;
        margin: auto;
        margin-top: 50px;
        height: auto;
    }

    @media (max-width: 500px) {
        width: 85%;
        margin: 0;
        margin-top: 25px;
        

        ::before {
            content: "";
            height: 190px;
            width: 10%;
            position: absolute;
            right: -10px;
            bottom: 0;
            background: inherit;
            border-radius: inherit;

        }
    }

    
`;

export const IconContainer = styled.div`
    width: 35px;
    height: 35px;
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FDE0C1 0% 0% no-repeat padding-box;
    border-radius: 8px;
`;

export const Title = styled.h1`
    font: normal normal normal 10px Circular Std Book;
    color: #B8B4CC;
    margin-bottom: 3px;
    line-height: 1;
`;

export const TotalValue = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    color: #F58B1E;
    line-height: 1;
    margin: 0;
`;

export const GraficBarContainer = styled.div`
    width: 100%;
    margin-top: 20px;
`;

export const GraficBarBackground = styled.div`
    width: 85%;
    height: 6px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 3px;
    margin-right: 5%;

    position: relative;
    display: inline-block;

    .tooltiptext {
        font: normal normal normal 10px Circular Std Book;
        visibility: hidden;
        width: auto;
        background-color: #B8B4CC;
        color: #fff;
        text-align: center;
        padding: 5px 7px;
        border-radius: 6px;

        position: absolute;
        z-index: 1;
        top: 0;
        transform: translateY(10px);
        left: 70%;
        margin-left: -60px;

        opacity: 0;
        transition: opacity 0.3s;
    }
    .tooltiptext::after {
        content: "";
        position: absolute;
        bottom: 100%;
        transform: rotate(-180deg);
        left: 30%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #B8B4CC transparent transparent transparent;
    }
    &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }
`;

export const GraficBarContent = styled.div`
    height: 100%;
    width: ${(p: GraficBarInterface) => p.width};
    background-color: ${(p: GraficBarInterface) => p.color};
    border-radius: 3px;
`;

export const PercentText = styled.span`
    font: normal normal normal 9px Circular Std Book;
    color: #454546;
`;

export const PostScritumContainer = styled.div`
    margin-top: 37px;
`
export const PostScritum = styled.p`
    font: normal normal normal 8px Circular Std Book;
    color: #B8B4CC;
    margin-bottom: 0px;
`